import React from "react";
import BaseLayout from "../../templates/BaseLayout/BaseLayout";
import StatusProcessTemplate from "../../templates/statusProcessTemplate/StatusProcessTemplate";

export default function StatusProcessPage() {
    return (
        <BaseLayout currentKey={"StatusProcess"} content={<StatusProcessTemplate />} />
    );
}